import { Box } from '@mui/material';
import { useFormik } from 'formik';
import FormikForm from 'src/components/common/FormikForm';
import FileUploadHistoryView from 'src/features/AIHSCodeLabeling/FileUploadHistoryView';
import FormBulkUploadStep1 from 'src/features/AIHSCodeLabeling/FormBulkUploadStep1';
import FormBulkUploadStep2 from 'src/features/AIHSCodeLabeling/FormBulkUploadStep2';
import { useBulkUploadSearchStore } from 'src/zustand/useAILabelingStore';

const FormBulkUploadSearch = () => {
  const formik = useFormik({
    onSubmit(values, formikHelpers) {},
    initialValues: {},
  });

  const { step, visibleHistoryBulkUpload, dispatch } = useBulkUploadSearchStore();

  const renderForm = () => {
    switch (step) {
      case 1:
        return <FormBulkUploadStep1 />;
      case 2:
        return <FormBulkUploadStep2 />;
      default:
        return null;
    }
  };

  return (
    <FormikForm formik={formik}>
      <Box mt={6} />
      <FileUploadHistoryView
        open={visibleHistoryBulkUpload}
        handleClose={() => dispatch(false, 'visibleHistoryBulkUpload')}
      />
      {renderForm()}
    </FormikForm>
  );
};

export default FormBulkUploadSearch;
